export { default } from "./RText";
